import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Spinner from "../Spinner";

type LoadingOverlayProps = {
	loading: boolean;
	children?: React.ReactNode;
};

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
	loading,
	children,
}) => {
	return (
		<Box>
			{children}
			{loading && (
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer * 2,
					}}
					open={loading}
				>
					<Spinner />
				</Backdrop>
			)}
		</Box>
	);
};

export default LoadingOverlay;
